/* eslint-disable import/no-anonymous-default-export */
// Version : 0.0.1
// Author : AGALYA
// LastEdit : SATHISH
// LastAdd : chanegs for code review correction
// MODFIED DATE:06-11-2025

import { docodeHexResponse } from '../../_common/common.utils';
import WorkFlowManagementActionTypes from './work-flow-management.types';

const INITIAL_STATE = {
	// GET ALL ROLE LIST RESPONSE AND ARRAY
	getAllRoleListResponse: null,
	getAllRoleListArr: [],

	// ADD CREDIT APPRAISAL DETAILS RESPONSE
	addCreditAppraisalDetailsResponse: null,

	// GET ALL CREDIT APPRAISAL LIST RESPONSE AND ARRAY
	getAllCreditAppraisalListResponse: null,
	getAllCreditAppraisalListArr: [],

	// DELETE CREDIT APPRAISAL DETAILS RESPONSE
	deleteCreditAppraisalDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET ALL ROLE LIST START *********************** */
		case WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_SUCCESS:
			return {
				...state,
				getAllRoleListResponse: action.payload,
				getAllRoleListArr: docodeHexResponse(
					action.payload,
					'FetchAllRoleListForCreditAppraisalListKey',
				),
			};

		case WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_FAILURE:
			return { ...state, getAllRoleListResponse: action.payload, getAllRoleListArr: null };

		case WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_RESPONSE_CHANGED:
			return { ...state, getAllRoleListResponse: null };
		/** ***************** GET ALL ROLE LIST END *********************** */

		/** ***************** ADD CREDIT APPRAISAL DETAILS START *********************** */
		case WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_SUCCESS:
			return { ...state, addCreditAppraisalDetailsResponse: action.payload };

		case WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_FAILURE:
			return { ...state, addCreditAppraisalDetailsResponse: action.payload };

		case WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, addCreditAppraisalDetailsResponse: null };

		/** ***************** ADD CREDIT APPRAISAL DETAILS END *********************** */

		/** ***************** GET ALL CREDIT APPRAISAL LIST START *********************** */

		case WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_SUCCESS:
			return {
				...state,
				getAllCreditAppraisalListResponse: action.payload,
				getAllCreditAppraisalListArr: docodeHexResponse(
					action.payload,
					'GetAllCreditAppraisalListKey',
				),
			};

		case WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_FAILURE:
			return {
				...state,
				getAllCreditAppraisalListResponse: action.payload,
				getAllCreditAppraisalListArr: null,
			};

		case WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_RESPONSE_CHANGED:
			return { ...state, getAllCreditAppraisalListResponse: null };
		/** ***************** GET ALL CREDIT APPRAISAL LIST END *********************** */

		/** ***************** DELETE CREDIT APPRAISAL DETAILS START *********************** */
		case WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_SUCCESS:
			return { ...state, deleteCreditAppraisalDetailsResponse: action.payload };

		case WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_FAILURE:
			return { ...state, deleteCreditAppraisalDetailsResponse: action.payload };

		case WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteCreditAppraisalDetailsResponse: null };
		/** ***************** DELETE CREDIT APPRAISAL DETAILS END *********************** */
		default:
			return state;
	}
};
